import { useState } from "react";
import { Grid, Button, Typography, Alert, FormLabel, Chip, Box } from "@mui/material";
import styles from './index.module.css';
import Snackbar from '@mui/material/Snackbar';

const Comment = ({ productData, estimationId, handleComments, saving = false, hideInPrint = false }) => {
  const [toast, setToast] = useState({ open: false, severity: 'error', message: '' });

  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') return;
    setToast({ open: false, severity: 'success' });
  };


  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={toast.open}
        onClose={handleCloseToast}
        autoHideDuration={3000}
      >
        <Alert severity={toast.severity} onClose={handleCloseToast}>
          {toast.message}
        </Alert>
      </Snackbar>

      <Grid item xs={11} className={hideInPrint ? styles.hideEstimatePdfComment : undefined}>
        <FormLabel className={styles.MuiFormLabelRoot}>{productData?.comment ? 'Your comments' : 'Select your comment'}</FormLabel>
        <Box sx={{
          display: 'flex',
          alignItems: 'center'
        }}>
          <Typography variant="h6" >
            Would you like to proceed with this product?
          </Typography>

          {!productData?.comment ? (<>
            <Button
              variant="contained"
              className={`${styles.AddCommentButton} ${styles.yesButton}`}
              onClick={() => handleComments(estimationId, productData, "Yes")}
              disabled={saving}
            >
              <Typography className={styles.ButtonTypography}>
                Yes
              </Typography>
            </Button>
            <Button
              variant="contained"
              className={`${styles.AddCommentButton} ${styles.noButton}`}
              onClick={() => handleComments(estimationId, productData, "No")}
              disabled={saving}
            >
              <Typography className={styles.ButtonTypography}>
                No
              </Typography>
            </Button>
          </>) :
            <Chip
              label={productData?.comment}
              color="primary"
              sx={{
                backgroundColor: '#81a7bdc2',
                color: 'white !important',
                marginLeft: '10px',
                fontSize: '1rem',
                padding: '8px',
                borderRadius: '5px !important',
                '& .MuiChip-label': {
                  color: 'white',
                },
              }}
            />
          }
        </Box>

      </Grid>
    </>
  );
};

export default Comment;
